module.exports = "/_next/static/files/49f157630444724d6a008c198708f754.png";